<template>
  <div class="text-sm">
    <p class="mt-6"><b>2024.11.01</b> - Dungeon Team ВЕРНУЛАСЬ.</p>
    <p>
      Мы снова за дело, друзья. Это был безумный, безумный год, но в итоге у меня появилось
      время для работы над DT на полную ставку. Релиз в Steam скоро. Следите за
      обновлениями.
    </p>
  </div>
</template>
